import type {EditorState} from "prosemirror-state";
import type {MarkType} from "prosemirror-model";

import {getStartEndByPos} from "./getStartEndByPos";

export const removeMarkByPosWithin = (state: EditorState, nodePos: number, markType: MarkType) => {
    const {startPos, endPos} = getStartEndByPos(state, nodePos);

    const tr = state.tr;
    tr.removeMark(startPos, endPos, markType);
    return tr;
}